export const API_URL: string = "https://jsonplaceholder.typicode.com";

export const USERS_PATH: string = "/users";

export const ALBUMS_PATH: string = "/albums";

export const PHOTOS_PATH: string = "/photos";

export const ALBUMS_BY_USER_ID_PATH: string = ALBUMS_PATH + "/byUserId/";